import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/*
 * Side-bar Component
 * different from Infowindow on map because of possible change requests to the side list
 */
import React, { useState, useRef, useLayoutEffect } from 'react';
import styled from 'styled-components';
import styles from './ListComponentMultiLocations.style';
import Para from '../../atoms/Para';
import Anchor from '../../atoms/Anchor';
import { FaCar } from 'react-icons/fa';
import { convertPhoneFormat } from '../../../utils/utilityFunction';
import Heading from '../../atoms/Heading';
import Address from '../../atoms/Address';
import Calendar from '../../../static/images/icons/Calendar';
import { buildGoogleDirections } from './Helper';
var ListComponentBlock = styled.section.withConfig({
  componentId: "sc-5dn0ku-0"
})(["", ";"], styles);
var ListComponent = function ListComponent(props) {
  var _selectedClinic$addre, _selectedClinic$addre2;
  var name = props.name,
    address = props.address,
    inputAddress = props.inputAddress,
    fax = props.fax,
    phoneNumber = props.phoneNumber,
    sms = props.sms,
    reservationLink = props.reservationLink,
    setSelectedClinic = props.setSelectedClinic,
    selectedClinic = props.selectedClinic,
    item = props.item,
    website = props.website,
    setData = props.setData,
    data = props.data,
    listOnClick = props.listOnClick,
    toggleMap = props.toggleMap,
    setTopOfSelectedCardToParent = props.setTopOfSelectedCardToParent,
    itemIndex = props.itemIndex,
    locationInformation = props.locationInformation;
  // console.log(`ListComponent`);
  // console.log(typeof locationInformation);
  // console.log(locationInformation?.includes('Phone Number'));
  /*
   * Method passed from child to parent component
   * to handle the map interaction when clicked from the sidebar
   * so that map zooms in when you click on a side list
   */

  // eslint-disable-next-line no-unused-vars
  var cardEl = useRef(null);
  useLayoutEffect(function () {
    if (cardEl.current && selectedClinic && selectedClinic.index === itemIndex) {
      var cardTop = cardEl.current.getBoundingClientRect();
      if (cardTop.height) {
        setTopOfSelectedCardToParent(cardTop.top);
      }
    }
    return function () {
      // cleanup
      setTopOfSelectedCardToParent(null);
    };
  }, [selectedClinic, cardEl, toggleMap]);
  return __jsx("div", {
    key: itemIndex,
    ref: cardEl
  }, __jsx(ListComponentBlock, {
    className: "nva-maps-multi-location__list-component"
  }, __jsx("div", {
    onClick: listOnClick || function (event) {
      if (selectedClinic && selectedClinic.yextRoutableCoordinate && selectedClinic.yextRoutableCoordinate.latitude === item.yextRoutableCoordinate.latitude) {
        return;
      }
      setData && setData(_objectSpread(_objectSpread({}, data), {}, {
        zoomLevel: 12
      }));
      setSelectedClinic(_objectSpread({}, item));
    },
    className: "nva-maps-multi-location__list-item list-item ".concat(selectedClinic && ((_selectedClinic$addre = selectedClinic.address) === null || _selectedClinic$addre === void 0 ? void 0 : _selectedClinic$addre.line1) === address.line1 && ((_selectedClinic$addre2 = selectedClinic.address) === null || _selectedClinic$addre2 === void 0 ? void 0 : _selectedClinic$addre2.postalCode) === address.postalCode ? 'selected is-selected' : '')
  }, website ? name && (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Location Name')) && __jsx(Heading, {
    title: name,
    HeadingType: "h3",
    className: "nva-maps-multi-location__list-item-location-title location-title"
  }, name) : name && (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Location Name')) && __jsx(Heading, {
    HeadingType: "h3",
    className: "location-title"
  }, name), __jsx("div", {
    className: "nva-maps-multi-location__list-item-address div-list-address"
  }, __jsx(Anchor, {
    title: "Get Directions",
    target: "_blank",
    to: buildGoogleDirections(address, inputAddress),
    rel: "noopener noreferrer"
  }, __jsx(Address, {
    className: "list-item-text",
    addressLine1: (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Address')) && address.line1,
    addressLine2: (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Address')) && address.line2,
    city: (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('City')) && address.city,
    state: (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Region')) && address.region,
    postalCode: (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Address')) && address.postalCode
  }))), __jsx("div", null, __jsx("div", null, phoneNumber && (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Phone Number')) && __jsx("div", {
    className: "nva-maps-multi-location__list-item-inline list-item-inline"
  }, __jsx("span", null, "Phone: "), __jsx(Anchor, {
    title: "Phone: ".concat(convertPhoneFormat(phoneNumber)),
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    href: "tel:".concat(convertPhoneFormat(phoneNumber)),
    to: "tel:".concat(convertPhoneFormat(phoneNumber)),
    className: "external-links",
    tabIndex: "0"
  }, __jsx("span", null, convertPhoneFormat(phoneNumber)))), sms && (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Text Phone Number')) && __jsx("div", {
    className: "nva-maps-multi-location__list-item-inline list-item-inline"
  }, __jsx("span", null, "Text: "), __jsx(Anchor, {
    title: "Text: ".concat(convertPhoneFormat(sms)),
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    href: "sms:".concat(convertPhoneFormat(sms)),
    to: "sms:".concat(convertPhoneFormat(sms)),
    className: "external-links",
    tabIndex: "0"
  }, __jsx("span", null, convertPhoneFormat(sms)))), fax && (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Fax Number')) && __jsx("div", {
    className: "nva-maps-multi-location__list-item-inline list-item-inline"
  }, __jsx("span", null, "Fax: "), __jsx(Anchor, {
    title: "Fax: ".concat(convertPhoneFormat(fax)),
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    href: "tel:".concat(convertPhoneFormat(fax)),
    to: "tel:".concat(convertPhoneFormat(fax)),
    className: "external-links",
    tabIndex: "0"
  }, __jsx("span", null, convertPhoneFormat(fax)))))), __jsx("div", {
    className: "nva-maps-multi-location__list-component-footer-content footer-content"
  }, __jsx("div", {
    className: "view-page-view-map-container"
  }, __jsx("div", null, locationInformation.includes('Website Display URL') && website ? __jsx(Anchor, {
    title: "Visit Site",
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    to: website,
    styleType: "primary-anchor",
    className: "map-btn",
    target: "_blank",
    rel: "noopener noreferrer",
    tabIndex: "0"
  }, __jsx("span", null, __jsx("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 512 512",
    className: "fa-icon",
    height: "1.5em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx("path", {
    d: "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
  }))), __jsx("span", null, "Visit Site")) : null)), locationInformation.includes('Reservation URL') && reservationLink ? __jsx(Anchor, {
    title: "Make Reservation",
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    styleType: "primary-anchor",
    className: "map-btn",
    to: reservationLink,
    target: "_blank",
    rel: "noopener noreferrer",
    tabIndex: "0"
  }, __jsx("span", {
    className: "icon"
  }, __jsx(Calendar, {
    className: "calendar-icon-happy"
  })), __jsx("span", {
    className: "class-span"
  }, "Book Now")) : null))));
};
export default ListComponent;